/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {FormatterFactory} from "../../Extensions/Core/Formatters";
import React from "react";

export class NumberFieldViewer extends BaseFieldViewer {
	@autobind
	_render() {
		const mergedProps = Object.assign(this.getFieldDefCustomData(), this.props);
		const {Value, isPrefix, suffix, className} = mergedProps;

		const formatter = this.props.FieldDef?.formatter;
		const formatterName = formatter?.name ?? 'NumberFormatter';
		const formatterParams = formatter?.params ?? [];

		const formattedValue = Value != null ? new FormatterFactory(formatterName, formatterParams).format(Value) : "";

		return <div className={className}>
			{isPrefix && Value != null ? suffix : ""} {formattedValue} {!isPrefix && Value != null ? suffix : ""}
		</div>;
	}
}